






















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Steppers',
  props: {
    num: { type: Number, default: 1 },
  },
  setup(props) {
    return {
      props,
    }
  },
})
